import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://career-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the CAREER READY™ Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full border-2 border-ink w-full max-w-md bg-sun px-4 py-[22px] text-center text-base font-extrabold sm:w-auto sm:max-w-none leading-none text-ink shadow-pop transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-x-0.5 hover:-translate-y-0.5 hover:bg-sun-deep hover:shadow-pop-lg active:translate-x-1 active:translate-y-1 active:shadow-none focus:outline-none focus-visible:ring-4 focus-visible:ring-royal/40 sm:px-14 sm:py-7 sm:text-2xl ${className}`} data-id="element-42" data-mp="qkahx974n9vh">
      <span data-id="element-43" data-mp="39yholr1zvndu">{label}</span>
      <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-44" data-mp="39xzm4coqocxh" />
    </a>;
}